<template>
  <ul
    class="bl-breadcrumb"
    :class="{'bl-breadcrumb--long': breadcrumbLists.length > 2}"
    :itemscope="setMicrodataAttr(true)"
    :itemtype="setMicrodataAttr('http://schema.org/BreadcrumbList')"
  >
    <li
      v-for="(breadcrumbList, index) in breadcrumbLists"
      :key="breadcrumbList.id || index"
      class="bl-breadcrumb__item"
      :itemprop="setMicrodataAttr('itemListElement')"
      :itemtype="setMicrodataAttr('http://schema.org/ListItem')"
      :itemscope="setMicrodataAttr(true)"
    >
      <BlLinkAv class="bl-link bl-breadcrumb__link" :itemprop="setMicrodataAttr('item')" :href="breadcrumbList.url">
        <span :itemprop="setMicrodataAttr('name')">{{ breadcrumbList.name }}</span>
        <meta v-if="withMicrodata" :content="index + 1" itemprop="position" />
      </BlLinkAv>
    </li>
  </ul>
</template>

<script>
import {BlLinkAv} from '@bukalapak/bazaar-mweb-latest';

// Cloned from bazaar-dweb
// To be able to used on both platform
export default {
  name: 'BlBreadcrumbAv',
  components: {
    BlLinkAv,
  },
  props: {
    /**
     * Array of breadcrumb
     */
    breadcrumbLists: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /**
     * Whether to use microdata
     * `true , false`
     */
    withMicrodata: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    /**
     * Set microdata attribute conditionally
     *
     * @type function
     * @event load
     */
    setMicrodataAttr(val) {
      return this.withMicrodata ? val : undefined;
    },
  },
};
</script>

<style src="@bukalapak/bazaar-dweb-next/dist/components/BlBreadcrumbAv.css" lang="scss"></style>
<style scoped lang="scss">
.bl-breadcrumb {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
}

.bl-breadcrumb__link {
  color: #2b4ac7;
  font-weight: 500;
}

.bl-breadcrumb__item:last-child ::v-deep .bl-breadcrumb__link {
  color: #3d3d3d;
  font-weight: 400;
}

// WORKAROUND: This is a workaround to prevent the second breadcrumb link from overflowing
.bl-breadcrumb--long .bl-breadcrumb__item:nth-child(2) {
  display: flex;
  align-items: center;
  max-width: 25vw;
}

.bl-breadcrumb--long .bl-breadcrumb__item:nth-child(2) ::v-deep .bl-breadcrumb__link {
  display: block;
  word-wrap: break-word;
  height: auto;
}
</style>
